import { Box, Button, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { GameCssStyles } from "../GameManagement/GameCssStyles";
import { MetadataSelectField } from "./CreateUpdateEntertainmentEntity/MetadataSelectField";
import { getYearRange } from "../../utility/Common";

const ShowFilterPane = ({ entertainment_entity_data, entertainment_entity_filter,
  showFilter,
  setShowFilter,
  applyFilter,
  setApplyFilter,
  entityType,
  setEntityType,
  languageFilter,
  setLanguageFilter,
  countryFilter,
  setCountryFilter,
  industryFilter,
  setIndustryFilter,
  artistTypeFilter,
  setArtistTypeFilter,
  year,
  setYear,
  handleClearFilters
}) => {
  return (
    showFilter && (
      <Box
        sx={{
          flex: 0.3,
          height: "102.4%",
          padding: 4,
          marginTop: 2,
          borderLeft: '1px solid #ccc',
          borderTop: '1px solid #ccc',
          borderBottom: '1px solid #ccc',
          background: '#f9f9f9',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h6" gutterBottom>Filters</Typography>

        {/* Entity Type Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Type</InputLabel>
          <Select
            value={entityType || ''}
            onChange={(e) => {
              setEntityType(e.target.value)
            }}
            label="Type"
            sx={GameCssStyles.formFiledStyle_sx2}
          >
            <MenuItem value="">All</MenuItem>
            {(entertainment_entity_filter?.EntertainmentEntityTypesV2).map((type) => {
              return (
                <MenuItem key={type?.value} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                  {type?.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>

        {/* Language Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Language</InputLabel>
          <Select
            value={languageFilter || ''}
            onChange={(e) => {
              setLanguageFilter(e.target.value)
            }}
            label="Language"
            sx={GameCssStyles.formFiledStyle_sx2}
          >
            <MenuItem value="">All</MenuItem>
            {(entertainment_entity_filter?.language).map((type) => {
              return (
                <MenuItem key={type?.value} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                  {type?.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>

        {/* Country Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Country</InputLabel>
          <Select
            value={countryFilter || ''}
            onChange={(e) => {
              setCountryFilter(e.target.value)
            }}
            label="Country"
            sx={GameCssStyles.formFiledStyle_sx2}
          >
            <MenuItem value="">All</MenuItem>
            {(entertainment_entity_filter?.country).map((type) => {
              return (
                <MenuItem key={type?.value} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                  {type?.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>

        {/* Industry Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Industry</InputLabel>
          <Select
            value={industryFilter || ''}
            onChange={(e) => {
              setIndustryFilter(e.target.value)
            }}
            label="Industry"
            sx={GameCssStyles.formFiledStyle_sx2}
          >
            <MenuItem value="">All</MenuItem>
            {(entertainment_entity_filter?.industry).map((type) => {
              return (
                <MenuItem key={type?.value} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                  {type?.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>

        {/* ArtistType Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Artist Type</InputLabel>
          <Select
            value={artistTypeFilter || ''}
            onChange={(e) => {
              setArtistTypeFilter(e.target.value)
            }}
            label="Artist Type"
            sx={GameCssStyles.formFiledStyle_sx2}
          >
            <MenuItem value="">All</MenuItem>
            {(entertainment_entity_filter?.ArtistType).map((type) => {
              return (
                <MenuItem key={type?.value} value={type.value} sx={GameCssStyles.menuItemStyle_sx}>
                  {type?.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>

        {/* Year Dropdown */}
        <MetadataSelectField
          label="Year"
          value={year || ''}
          onChange={(value) => setYear(value)}
          options={getYearRange(1900).map((year) => ({ _id: year, value: year, label: year }))}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            mt: 'auto',
            alignSelf: 'center',
          }}
        >

          <Button
            variant="contained"
            color="success"
            sx={{
              mt: 'auto',
              alignSelf: 'center',
              borderRadius: 2,
              textTransform: "none",
              px: 4
            }}
            onClick={() => {
              setApplyFilter(true)
            }}
          >
            Apply
          </Button>

          <Button
            variant="contained"
            color="error"
            sx={{
              mt: 'auto',
              alignSelf: 'center',
              borderRadius: 2,
              textTransform: "none",
              px: 4
            }}
            onClick={() => {
              handleClearFilters()
            }}
          >
            Clear
          </Button>

        </Box>

      </Box>
    )
  );
}


export default ShowFilterPane;